<template>
    <section class="sheet" id="result-report"> <!--  :class="{'rapor-yeni': showFigma}" -->
        <div style="margin-top:33pt; margin-right:40pt; margin-left:40pt;" v-show="showReal">

            <div style="position:relative; border-bottom:1.2pt solid #0068FF; height:20pt; width:515pt;"> <!-- DEVNOTE: if children are floating, overflow:hidden needed to make parent grow with content. -->
                <div style="position:absolute; bottom:3pt; left:0; font-size:12pt; ">{{ $t('report.uroflow_report') }}</div>
                <div style="position:absolute; bottom:3pt; right:0;"><img src="../assets/oruflow_2x.png" style="width:62pt" alt="Institution Logo"></div>
            </div>

            <div style="height:98pt; width: 100%; display:table; overflow:hidden">
                <div class="report-logo" v-show="systemConfig.LogoEnabled">
                    <img :src="hturl('/logo')" style="width:90pt; max-height:46pt;" alt="Institution Logo">
                </div>
                <div class="report-fields">
                    <table style="width:100%;">
                        <tr v-for="r in reportFields" :key="r.id">
                          <td>{{ r.left ? r.left.name : '' }}</td>
                          <td>{{ r.left ? r.left.value : '' }}</td>
                          <td>{{ r.right ? r.right.name : '' }}</td>
                          <td>{{ r.right ? r.right.value : '' }}</td>
                        </tr>
                    </table>
                </div>
            </div>

            <div style="position:relative; display: inline-block; width: 514pt; height:300pt; margin-bottom:21pt; "><!-- background-color: rgba(255, 255, 0, 0.2) -->
                <div style="position:absolute; color:#0068FF; bottom:0; height:20pt; transform: rotate(-90deg); transform-origin: top left;"> <!--  -->
                  <div class="chart-title">Qura (ml/s)</div><div class="chart-title" style="margin-left:3pt;">Vmic (ml)</div>
                </div>
                <svg id="chartResultV2" />
            </div>

            <div class="nomogram-title" style="margin-left:8pt;">Siroky nomogram - {{ $t('report.avg_flow_rate') }}</div><div class="nomogram-title" style="margin-left:8pt;">Siroky nomogram - {{ $t('report.max_flow_rate') }}</div>
            <Nomogram-Dev id="nomogram" ref="nomogram"></Nomogram-Dev>
            <div style="clear:both;"></div>

            <div style="height:164pt; display:inline-block; float:left;">
              <div class="nomogram-title" style="margin-left:8pt;">{{ $t('report.results') }}</div>
              <table class="results-table">
                <tr><th>{{ $t('report.avg_flow_rate') }}</th><td>{{ exam_detail.average_speed }} ml/s</td></tr>
                <tr><th>{{ $t('report.max_flow_rate') }}</th><td>{{ exam_detail.max_speed }} ml/s</td></tr>
                <tr><th>{{ $t('report.time_to_max_flow') }}</th><td>{{ exam_detail.max_speed_time }} s</td></tr>
                <tr><th>{{ $t('report.voided_volume') }}</th><td>{{ exam_detail.total_volume }} ml</td></tr>
                <tr><th>{{ $t('report.voiding_time') }}</th><td>{{ exam_detail.duration }} s</td></tr>
                <tr><th>{{ $t('report.flow_time') }}</th><td>{{ exam_detail.flow_time }} s</td></tr>
                <tr><th>{{ $t('report.delay_time') }}</th><td>{{ exam_detail.delay_time }} s</td></tr>
                <tr v-if="survey"><th>IPSS Skoru</th><td>{{ survey.ui_score }}</td></tr>
                <tr v-if="survey"><th>IPSS Hayat kalitesi</th><td>{{ survey.ui_qol }}</td></tr>
                <tr v-show="exam_detail.pvr && systemConfig.PVREnabled">
                  <th>{{ $t('report.pvr') }}</th>
                  <td>{{ exam_detail.pvr }} ml</td>
                </tr>
              </table>
            </div>

            <div style="height:164pt; display:inline-block;" v-show="!exam_detail.urine_analysis">
              <div class="nomogram-title" style="margin-left:8pt;">{{ $t('report.comments') }}</div>
              <div v-show="exam_detail.comment" class="comment-box">{{ exam_detail.comment }}</div>
              <table v-show="!exam_detail.comment" class="comments-table" style="margin-left:14pt;">
                <tr><td></td></tr>
                <tr><td></td></tr>
                <tr><td></td></tr>
                <tr><td></td></tr>
                <tr><td></td></tr>
                <tr><td></td></tr>
              </table>
            </div>

            <div style="height:164pt; display:inline-block;" v-show="exam_detail.urine_analysis">
              <div class="nomogram-title" style="margin-left:8pt;">{{ $t('urine_analysis.report_header') }}</div>
              <div>
                <table class="ua-table" style="width:70%;">
                    <tr v-for="r in urineAnalysis.Results[0]" :key="r.id" :style="{ backgroundColor: r.is_positive === true ? '#f4cccc' : (r.is_positive === false ? '#d9ead3' : '') }">
                      <td style="width:60%; padding: 0px; vertical-align: middle;">{{ $t('urine_analysis.' + r.param_name) }}</td>
                      <td style="text-align:left; padding: 0px; vertical-align: middle;">{{ ua_result(r.txt, r.report_str) }}</td>
                    </tr>
                </table>

              </div>
            </div>

            <div style="overflow:hidden; position:absolute; width:515pt; bottom:12pt"> <!-- DEVNOTE: if children are floating, overflow:hidden needed to make parent grow with content. -->
                <div style="float:left; font-size:12pt; line-height:14pt;"><img src="../assets/oruba_2x.png" style="width:69pt" alt="Oruba Logo"></div>
                <div style="float:right; font-size:9pt; line-height:12pt; text-align:right;">
                  <span style="display:block">{{ $t('report.print_date') }}</span>
                  <span style="display:block">{{ customDate }}</span>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import GenericChart from '../GenericChart'
import NomogramDev from './NomogramDev'
import Settings from '../settings'

// function getDescendantProp (obj, desc) {
//   var arr = desc.split('.')
//   while (arr.length && (obj = obj[arr.shift()]));
//   return obj
// }

export default {
  props: ['title'],
  components: {
    NomogramDev
  },
  data () {
    return {
      survey: null,
      exam_detail: { patient: {} },
      systemConfig: {},
      show_uroflowmetry: true,
      customDate: '',
      deviceHelper: true,
      showReal: true,
      showFigma: false,
      reportFields: [],
      urineAnalysis: { 'Results': [[]] }
    }
  },
  methods: {
    hturl (path) {
      return 'http://' + Settings.host + ':6161' + path
    },
    ua_result (txt, reportStr) {
      let result = ''
      console.log('ua_result', txt, reportStr)

      // Light Red 3: #f4cccc
      // Light Green 3: #d9ead3

      if (reportStr) {
        if (reportStr.trim() === 'Negative') {
          result = this.$t('urine_analysis.Negative')
        } else if (reportStr.trim() === 'Positive') {
          result = this.$t('urine_analysis.Positive')
        } else if (reportStr.trim() === 'Trace') {
          result = this.$t('urine_analysis.Trace')
        } else {
          result = reportStr
        }
      } else if (txt) {
        result = txt
      }

      return result
    }
  },
  created () {
    var vm = this
    vm.deviceHelper = Settings.deviceHelper

    console.log(vm.deviceHelper)

    /*
        <input type="checkbox" id="checkbox1" @change=""><label for="checkbox1">Integration.Mode: {{ systemConfig['Integration.Mode'] }}</label>
        <input type="checkbox" id="checkbox2" @change=" = $event.target.checked"><label for="checkbox2">DEVICE102: {{ systemConfig['DEVICE102'] }}</label>
        <input type="checkbox" id="checkbox3" @change="systemConfig['DEVICE'] = $event.target.checked ? 145 : 254"><label for="checkbox3">DEVICE: {{ systemConfig['DEVICE'] }}</label>
    */

    /* if (vm.deviceHelper) {
      document.addEventListener('keydown', function (event) {
        if (event.keyCode === 48) {
          vm.deviceHelper = !vm.deviceHelper
        } else if (event.keyCode === 49) {
          document.getElementById('checkbox1').checked = !document.getElementById('checkbox1').checked
          vm.systemConfig['Integration.Mode'] = document.getElementById('checkbox1').checked ? 'HL7_BYPASS' : 'MANUAL'
        } else if (event.keyCode === 50) {
          document.getElementById('checkbox2').checked = !document.getElementById('checkbox2').checked
          vm.systemConfig['DEVICE102'] = document.getElementById('checkbox2').checked
        } else if (event.keyCode === 51) {
          document.getElementById('checkbox3').checked = !document.getElementById('checkbox3').checked
          vm.systemConfig['DEVICE'] = document.getElementById('checkbox3').checked ? 145 : 254
        } else if (event.keyCode === 52) {
          document.getElementById('checkbox4').checked = !document.getElementById('checkbox4').checked
          vm.systemConfig['DEVICE139'] = document.getElementById('checkbox4').checked
        } else if (event.keyCode === 53) {
          document.getElementById('checkbox5').checked = !document.getElementById('checkbox5').checked
          vm.systemConfig['PDFRemote'] = document.getElementById('checkbox5').checked
        } else if (event.keyCode === 54) {
          document.getElementById('checkbox6').checked = !document.getElementById('checkbox6').checked
          vm.systemConfig['LogoStyle'] = document.getElementById('checkbox6').checked
        }
      })
    } */
  },
  mounted () {
    console.log('printout mounted')

    // document.addEventListener('keydown', function (event) {
    //   if (event.keyCode === 49) {
    //     vm.showReal = !vm.showReal
    //   } else if (event.keyCode === 50) {
    //     vm.showFigma = !vm.showFigma
    //   }
    // })

    /* if (this.$route.query.print || this.$route.query.printdev) {
      console.log('EKLENİYOR')
      var newStyle = document.createElement('style')
      newStyle.appendChild(document.createTextNode("@font-face { font-family: Roboto; src: url('/static/Roboto-Regular.ttf') format('truetype'); }"))

      document.head.appendChild(newStyle)
    } */

    var examId = this.$route.params.examId

    var vm = this

    var chartConfig = {

      width: 655,
      height: 395,
      margin: { top: 5, bottom: 21, left: 30, right: 10 },
      interpolation: 'monotone',
      tickInterval: 1000,
      orientation: 'horizontal',
      axisLabels: 'disabled',
      // tickEvery: 5,
      chartType: 'static',
      invisible_points: 0,
      totalTime: 19000,
      translation: vm.$t,
      EMGEnabled: true,

      tickConfig: {
        verticalTicks: true
      },
      lineStrokeWidth: 1.5 // should match css "stroke-width"
    }

    vm.historyChart = new GenericChart(document.querySelector('svg'), chartConfig)

    Promise.all([
      this.$http.get('http://' + Settings.host + ':6161/' + 'api/exam_detail/' + examId),
      this.$http.get('http://' + Settings.host + ':6161/' + 'api/config')
    ]).then((response) => { // success
      vm.systemConfig = response[1].data
      var exam = response[0].data

      var w = []
      var s = []
      var e = []

      if (exam.weight_array) {
        w = exam.weight_array.split(' ').map(function (item) { return parseFloat(item, 10) })
        s = exam.speed_array.split(' ').map(function (item) { return parseFloat(item) })
      }

      if (exam.emg_array) {
        e = exam.emg_array.split(' ').map(function (item) { return parseFloat(item) })
      }

      var weight = []
      var speed = []
      var emg = []

      for (let i = 0; i < w.length; i++) {
        let t = new Date(i * 1000)
        weight.push([t, w[i]])
        speed.push([t, s[i]])
      }

      for (let i = 0; i < e.length; i++) {
        let t = new Date(i * 100)
        emg.push([t, e[i]])
      }

      //                     <td>{{ $t("report.institution") }}</td>
      //                     <td>{{ systemConfig['Institution'] }}</td>
      //                     <td>{{ $t("result_ui.name") }}</td>
      //                     <td>{{ exam_detail.patient.name }}</td>
      //                   </tr>
      //                   <tr>
      //                     <td>{{ $t("report.exam_date") }}</td>
      //                     <td>{{ exam_detail.created }}</td>
      //                     <td>{{ $t("result_ui.surname") }}</td>
      //                     <td>{{ exam_detail.patient.surname }}</td>
      //                   </tr>
      //                   <tr>
      //                     <td>{{ $t(systemConfig.BarcodeNumberLiteral) }}</td>
      //                     <td>{{ exam_detail.patient.value2 }}</td>
      //                     <td>{{ $t("report.sex") }}</td>
      //                     <td>{{ exam_detail.patient.gender }}</td>
      //                   </tr>
      //                   <tr>
      //                     <td></td>
      // }

      vm.exam_detail = exam
      console.log('exam_detail populated')

      if (vm.exam_detail.urine_analysis) {
        try {
          vm.exam_detail.urine_analysis = JSON.parse(vm.exam_detail.urine_analysis)
          vm.urineAnalysis = vm.exam_detail.urine_analysis
        } catch (e) {
          console.log(e)
        }
      } else if (vm.deviceHelper) {
        vm.exam_detail.urine_analysis = {'StripOrder': 3, 'Results': [[{'param_name': 'Glucose', 'report_str': 'Negative', 'is_positive': false, 'txt': '0', 'wet_time': 30}, {'param_name': 'Bilirubin', 'report_str': 'Negative', 'is_positive': false, 'txt': '0', 'wet_time': 30}, {'param_name': 'Ketone', 'report_str': 'Negative', 'is_positive': false, 'txt': '0', 'wet_time': 40}, {'param_name': 'SpecificGravity', 'report_str': '1.005', 'is_positive': null, 'txt': '1', 'wet_time': 45}, {'param_name': 'Blood', 'report_str': 'Negative', 'is_positive': false, 'txt': '0', 'wet_time': 60}, {'param_name': 'pH', 'report_str': '7.5', 'is_positive': null, 'txt': '4', 'wet_time': 60}, {'param_name': 'Protein', 'report_str': 'Negative', 'is_positive': false, 'txt': '0', 'wet_time': 60}, {'param_name': 'Urobilinogen', 'report_str': '0.2 E.U./dL', 'is_positive': false, 'txt': '0', 'wet_time': 60}, {'param_name': 'Nitrite', 'report_str': 'Positive', 'is_positive': true, 'txt': '2', 'wet_time': 60}, {'param_name': 'Leukocytes', 'report_str': 'Negative', 'is_positive': false, 'txt': '0', 'wet_time': 120}]]}
        vm.urineAnalysis = vm.exam_detail.urine_analysis
      }

      vm.exam_detail.patient.birth_date = vm.exam_detail.patient.birth_date.substring(0, 10) // DEVNOTE: Dirty operation
      if (vm.exam_detail.patient.birth_date === '01.01.1900') { vm.exam_detail.patient.birth_date = '-' }

      let genderDict = {
        0: vm.$t('report.female'),
        1: vm.$t('report.male'),
        2: vm.$t('report.unknown')
      }

      vm.exam_detail.patient.gender = genderDict[vm.exam_detail.patient.gender] || vm.exam_detail.patient.gender

      var literalMapping = {
        's.Institution': { name: vm.$t('report.institution'), value: vm.systemConfig.Institution },
        'e.created': { name: vm.$t('report.exam_date'), value: vm.exam_detail.created },
        'e.extra_info': { name: vm.$t(vm.systemConfig.BarcodeNumberLiteral), value: vm.exam_detail.extra_info },
        'e.patient.name': { name: vm.$t('result_ui.name'), value: vm.exam_detail.patient.name },
        'e.patient.surname': { name: vm.$t('result_ui.surname'), value: vm.exam_detail.patient.surname },
        'e.patient.gender': { name: vm.$t('report.sex'), value: vm.exam_detail.patient.gender },
        'e.patient.birth_date': { name: vm.$t('report.birth_date'), value: vm.exam_detail.patient.birth_date },
        'e.patient.his_patient_id': { name: vm.$t('result_ui.patient_id'), value: vm.exam_detail.patient.his_patient_id },
        'e.doctor': { name: vm.$t('result_ui.doctor'), value: vm.exam_detail.doctor }
      }

      vm.reportFields = []

      var lines = Math.max(vm.systemConfig.ReportLeftFields.length, vm.systemConfig.ReportRightFields.length)

      for (var l = 0; l < lines; l++) {
        let leftField = literalMapping[vm.systemConfig.ReportLeftFields[l]]
        let rightField = literalMapping[vm.systemConfig.ReportRightFields[l]]
        vm.reportFields.push({id: l, left: leftField, right: rightField})
      }

      console.log(vm.reportFields)

      if (exam.weight_array) {
        vm.exam_detail.max_speed = vm.exam_detail.max_speed.toFixed(1)
        vm.exam_detail.average_speed = vm.exam_detail.average_speed.toFixed(1)
        vm.exam_detail.total_volume = vm.exam_detail.total_volume.toFixed(1)

        vm.$refs.nomogram.dots({average_speed: vm.exam_detail.average_speed, max_speed: vm.exam_detail.max_speed, total_volume: vm.exam_detail.total_volume})
      }

      console.log(vm.exam_detail)

      if (vm.exam_detail.survey) {
        vm.survey = {}
        vm.survey.ui_qol = vm.exam_detail.survey.ipss[7]

        var score = 0
        for (var i = 0; i < 7; i++) {
          score += parseInt(vm.exam_detail.survey.ipss[i])
        }
        vm.survey.ui_score = score
      }

      vm.$nextTick(function () {
        vm.historyChart.initDrawing(weight, speed, emg, vm.systemConfig['Chart.Scale'], vm.systemConfig['EMG.Chart.Scale'])

        // if (this.$route.query.print) { window.print() }
        if (exam.emg_array && weight.length) {
          console.log('Uroflowmetry+EMG result.')
          vm.show_uroflowmetry = true
          vm.historyChart.emgEnable(true)
        } else if (exam.emg_array && !weight.length) {
          console.log('EMG result.')
          vm.show_uroflowmetry = false
          vm.historyChart.emgEnable(true, true)
        } else {
          console.log('Uroflowmetry result.')
          vm.show_uroflowmetry = true
          vm.historyChart.emgEnable(undefined, false)
        }

        var m = new Date()
        var dateString =
            ('0' + m.getDate()).slice(-2) + '.' +
            ('0' + (m.getMonth() + 1)).slice(-2) + '.' +
            m.getFullYear() + ' ' +
            ('0' + m.getHours()).slice(-2) + ':' +
            ('0' + m.getMinutes()).slice(-2) + ':' +
            ('0' + m.getSeconds()).slice(-2)
        vm.customDate = dateString

        vm.$nextTick(function () {
          console.log('STATIC_CHART_LOADED')

          if (this.$route.query.print === 'yes') {
            var filename = (vm.exam_detail.patient.surname + ' ' + vm.exam_detail.patient.name + ', ' + vm.exam_detail.patient.birth_date + ', ' + vm.exam_detail.created)
            // var tempTitle = document.title
            document.title = filename + '.pdf'
            window.print()
            // document.title = tempTitle // Bu satır eğer olursa windows'taki Chrome'da sorun çıkarıyor. Hemen burasını çalıştırıyor, bir anlamı kalmıyor.
          }
        })
      })

      // vm.historyChart.initDrawing();
    }, (response) => { // error
      console.log(response)
    })
  }
}
</script>

<style>
@import url('../assets/fonts/roboto/roboto.css');

#result-report div {
    font-family:Roboto, Helvetica, Arial;
}

.tiling-box {
    height: 50pt;
    width: 253pt;
    background-color: yellow;
    display: inline-block;
    margin-bottom: 14pt;
    background-color: rgba(255, 255, 0, 0.2)

}

.report-logo {
    overflow: hidden;
    /* border: 2px dashed #f0f; */
    height: 100%;
    width: 100pt;
    display:table-cell;
    /* display: none; */
    vertical-align: middle;
    /* float:left; */
}

.report-fields {
    display:table-cell;
    /* display:inline-block; */
    vertical-align: middle;
    padding-left: 52pt;
    height: 98pt;
    font-size:10pt;
    width: 100%;
    /* border: 2px dashed #00f; */
}

.rapor-yeni {
    background-image: url('../assets/rapor_yeni.png');
    background-size: 793px;
    background-color: bisque;
    background-position: left top;
}

.report-fields table { margin: 0 auto; }

.report-fields td { line-height:16pt; }

.report-fields td:nth-child(1), .report-fields td:nth-child(3) {
    color: #0068FF;
    width: 60pt;
}

.report-fields td:nth-child(2) { width: 150pt; }
.report-fields td:nth-child(4) { width: 100pt; }

/* dt:after { content:":"; } */
/* dt, dd { float: left; }
dd { margin-left: 5px }
dl { float: left; width: 40pt; margin-left: 90pt; border: 1pt dashed transparent; }
dt { color: #0068FF; width: 55pt; } */
/* dl:hover { border-color: red; } */

#chartResultV2 {
  margin-left: 10mm;
}

#chartResultV2 .axis {
  /*font: 10px sans-serif;*/
  font-size: 7pt;
}

#chartResultV2 .axis path,
#chartResultV2 .axis line1,
#chartResultV2 .axis line2,
#chartResultV2 .axis line3 {
  fill: none;
  /*stroke: #dfdfdf;*/
  shape-rendering: crispEdges;
}

#chartResultV2 .axis--x line, #chartResultV2 .axis--y1 line, #chartResultV2 .axis--y2 line, #chartResultV2 .axis--y3 line {
  /* stroke: #dfdfdf; */
  stroke: #D9E7FF;
  /* stroke-dasharray: 1, 3; */
  /* fill: none; */
  stroke-width: 1.0px;
  /*stroke-width:1px;*/
}

/* below selector disabled. see GenericChart.js (hacky way to add right line of square around chart) */
/* #chartResultV2 .axis--x .tick:nth-last-child(2) line, */ #chartResultV2 .axis--x .tick:first-child line,
#chartResultV2 .axis--y1 .tick:nth-last-child(2) line, #chartResultV2 .axis--y2 .tick:nth-last-child(2) line, #chartResultV2 .axis--y3 .tick:nth-last-child(2) line
#chartResultV2 .axis--y1 .tick:first-child line, #chartResultV2 .axis--y2 .tick:first-child line, #chartResultV2 .axis--y3 .tick:first-child line
 {
  stroke: #0068FF;
}

#chartResultV2 .axis--y1 text, #chartResultV2 .axis--y2 text, #chartResultV2 .axis--y3 text {
  visibility: visible;
}

#chartResultV2 .axis--y1 .tick:nth-last-child(2) text, #chartResultV2 .axis--y2 .tick:nth-last-child(2) text, #chartResultV2 .axis--y3 .tick:nth-last-child(2) text {
  transform: translate(0px, 7px);
  visibility: visible;
}

#chartResultV2 .axis--y1 .tick:first-child text, #chartResultV2 .axis--y2 .tick:first-child text, #chartResultV2 .axis--y3 .tick:first-child text {
  transform: translate(0px, -7px);
  visibility: visible;
}

#chartResultV2 .line1 {
  fill: none;
  /*stroke: steelblue;*/
  stroke: #0260FB;
  stroke-width: 2px;
}

#chartResultV2 .line2 {
  fill: none;
  /*stroke: steelblue;*/
  stroke: green;
  stroke-width: 2px;
}

#chartResultV2 .line3 {
  fill: none;
  /*stroke: steelblue;*/
  stroke: none;
  stroke-width: 2px;
}

#nomogram .nomogramDev {
  font-family: Roboto;
  font-size: 8pt;
}

.chart-title {
  text-align:center; line-height:18pt; font-size:10pt; display: inline-block; width:137pt; background-color:#D9E7FF; height: 100%;
}

.nomogram-title {
  font-weight:bold;
  font-size:8pt;
  width:230pt;
  line-height:16pt;
  height:16pt;
  padding-left:10pt;
  text-transform: uppercase;
  background-color:#F4F8FF;
  color:#0068FF;
  display: inline-block;
}

.comment-box {
  margin-left:8pt;
  width: 200pt;
  height: 110pt;
  overflow:hidden;
  font-size:10pt;
  margin-left:20pt;
  margin-top:5pt;
  line-height:12pt;
}

.comments-table td {
  width:230pt;
  height:20pt;
  border-bottom: solid 1pt #C4C4C4;
}

.results-table { margin-top:10pt; margin-left:22pt; }

.results-table th {
  width: 130pt;
}

.results-table th, .results-table td {
  color:black;
  font-size: 11pt;
  text-align: left;
  height:15pt;

}

.ua-table { margin-top:3pt; margin-left:22pt; }

.ua-table th {
  width: 100pt;
}

.ua-table th, .ua-table td {
  color:black;
  font-size: 10pt;
  text-align: left;
  height:13pt;

}

</style>



// WEBPACK FOOTER //
// src/components/PrintoutV2.vue